import { RG_TYPE } from "@project-rouge/rg-core";
function getCoreCost(state, props) {
  if (props.skipCores) {
    return 0;
  }
  const coreCost = state.sequence.filter((u) => u.unit.type === RG_TYPE.Core).length * props.dataset.aggConfig.maxTravelDistBidirectional * 2 / state.totalLength;
  return coreCost;
}
export {
  getCoreCost
};
//# sourceMappingURL=index200.js.map
